// PurchaseRequestDetails.js
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, NavLink, Outlet, useParams } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

//custom components
import Button from "Components/Button";
import { useDispatch } from "react-redux";
import { fetchSingleFailureAnalysisRequest, downloadFARReport, getFarReport } from "../../../../Redux/Slices/failureAnalysisReqSlice";
import ReportDownload from "Components/ReportDownload";

const FailureAnalysisRequestDetails = () => {
  const [details, setDetails] = useState({});
  const [pdfReport, setPdfReport] = useState(null)
  const [isShowDownload, setIsShowDownload] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const downloadRef = useRef()
  const failureAnalysisRequestNavLinks = [
    {
      to: "failureDetails",
      label: "Bearing Failure Details",
      id: "1",
    },
    {
      to: "assetDetails",
      label: "Asset Details",
      id: "2",
    },
    {
      to: "drives",
      label: "Drives",
      id: "3",
    },
    {
      to: "lubricationDetails",
      label: "Lubrication Details",
      id: "4",
    },
  ];

  let navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    getIndividualData();
    getFarRdfReportData();
  }, []);

  const getIndividualData = () => {
    dispatch(
      fetchSingleFailureAnalysisRequest({
        data: {
          remote_failure_details_id: id,
        },
        callBack: getDetails,
      })
    );
  };

  const getFarRdfReportData = () => {
    dispatch(
      getFarReport({
        data: {
          remote_failure_details_id: id
        },
        callBack: (responseData) => {
          setPdfReport(responseData?.result)
        }
      })
    );
  }

  const downloadFarReport = (id) => {
    // dispatch(
    // downloadFARReport({
    //   data: {
    //     remote_failure_details_id: id,
    //   },
    //   callBack: (responseData) => {
    //     if (responseData?.data) {
    //       window.open(responseData.data, "_blank"); 
    //     } else {
    //       console.error("Failed to fetch report URL");
    //     }
    //   },
    // })
    // );
    setIsShowDownload(true);
    setIsLoading(true)

    setTimeout(async () => {
      try {
        if (downloadRef.current) {
          await downloadRef.current.download();
        } else {
          console.error("Download ref not ready");
        }
      } catch (err) {
        console.error("Download failed", err);
      } finally {
        setIsShowDownload(false);
        setIsLoading(false)
      }
    }, 100);
  };

  const getDetails = (data) => {
    setDetails(data?.result);
  };

  const remote_failure_details_id = details?.remote_failure_details_id;
  const no_of_bearings =
    details?.remote_failure_asset_details?.remote_failure_bearing_info_details
      ?.number_of_bearings_id;
  const report_status = details?.report_status;

  return (
    <MainLayout pageName="Failure Analysis Requests">
      <div
        className="goBackDivFailureRequests"
        onClick={() => navigate("/request/failureAnalysisRequest")}
      >
        <img src={assets.Icons.backArrow} alt="backIcon" />
        <p>Back to Requests</p>
      </div>
      <div className="failureRequestDetailsContainer">
        {/* Header */}
        <div className="failureRequestDetailsHeader">
          <h2>Failure Analysis Request Details</h2>
          {(report_status === 1 || report_status === 2) ? (
            <Button
              title="Generate Report"
              buttonStyle={{ width: "13vw", height: "1vw" }}
              titleStlye={{ color: "#FFFFFF", fontWeight: "500" }}
              onClick={() =>
                navigate("/request/failureAnalysisRequest/sendReport", {
                  state: {
                    remote_failure_details_id: remote_failure_details_id,
                  },
                })
              }
            />
          ) : (
            <Button
              title="View Report"
              buttonStyle={{ width: "13vw", height: "1vw" }}
              titleStlye={{ color: "#FFFFFF", fontWeight: "500" }}
              onClick={() => {
                if (remote_failure_details_id) {
                  downloadFarReport(remote_failure_details_id);
                } else {
                  console.error("Missing remote_failure_details_id");
                }
              }}
            />
          )}
        </div>
        <div className="failureRequestDetailsBody">
          <div className="failureRequestNavBar">
            {failureAnalysisRequestNavLinks.map((option) => (
              <div key={option.id} className="requestOptionContainer">
                <NavLink
                  key={option.id}
                  to={option.to}
                  style={{ textDecoration: "none" }}
                  className={({ isActive }) =>
                    isActive
                      ? "active-requestOptionContainerNav"
                      : "requestOptionContainerNav"
                  }
                >
                  {option.label}
                </NavLink>
              </div>
            ))}
          </div>
          <Outlet />
        </div>
      </div>
      {
        isShowDownload &&
        <ReportDownload resultData={pdfReport} ref={downloadRef} />
      }

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#1f2155",
            fontFamily: "Poppins, sans-serif",
            zIndex: 10000,
            textAlign: "center",
          }}>
          <h2 style={{ marginBottom: "10px", fontSize: "4vh" }}>Loading</h2>
          <p style={{ fontSize: "14px" }}>
            Do not refresh or go back. Your Report is being downloaded. Please wait.
          </p>
        </div>
      )}

    </MainLayout>
  );
};

export default FailureAnalysisRequestDetails;
